import React from 'react'
import MainScreen from '../../components/MainScreen/MainScreen'
import InfoBlock from '../../components/InfoBlock/InfoBlock'
import SpesialBlock from '../../components/SpecialBlock/SpesialBlock'
import ServicesBlock from '../../components/ServicesBlock/ServicesBlock'
import CommunicationBlock from '../../components/CommunicationBlock/CommunicationBlock'
import QuestionBlock from '../../components/QuestionBlock/QuestionBlock'
import Employee from '../../components/Employee/Employee'
import WorkBlock from '../../components/WorkBlock/WorkBlock'
import SecondCommunicationBlock from '../../components/SecondCommunicationBlock/SecondCommunicationBlock'
import { questionBlockContent } from '../../data/questions'

const Home = () => {
  return (
    <div>
      <MainScreen/>
      
      <InfoBlock/>
      <SpesialBlock/>
      <ServicesBlock/>
      <CommunicationBlock/>
      <QuestionBlock
        items={questionBlockContent.main.items}
        title={questionBlockContent.main.title}
        description={questionBlockContent.main.description}
        ariaLabel={questionBlockContent.main.ariaLabel}
      />
      <Employee/>
      <WorkBlock/>
      <SecondCommunicationBlock/>
    </div>
  )
}

export default Home
